module.exports = __webpack_public_path__ + "static/media/ic_privacy_policy.952fdd11.svg";